import { urlWithParams } from '@marketplace-web/browser/url-util'

export const INBOX_URL = '/inbox'
export const CONVERSATION_URL = (conversationId: number | string): string =>
  `/inbox/${conversationId}`

export const CONVERSATION_DETAILS_URL = (conversationId: number | string): string =>
  `/inbox/${conversationId}/details`

export const INBOX_WANT_IT_PATH = (receiverId: number | string, itemId: number | string): string =>
  `/inbox/want_it?receiver_id=${receiverId}&item_id=${itemId}`

export const INBOX_ROUTE_PATHS = {
  INBOX: 'inbox/*',
  CONVERSATION: ':id',
  CONVERSATION_DETAILS: 'details',
  WANT_IT: 'want_it',
}

export const INBOX_FULL_ROUTE_PATHS = {
  CONVERSATION: 'inbox/:id',
  CONVERSATION_DETAILS: 'inbox/:id/details',
}

export const CONVERSATION_ID_REGEX = {
  old: /^\d+$/,
  new: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
}

export const ID_REGEX = /^\/inbox(?:\/(\d+))?/

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })

export const ITEM_UPLOAD_URL = '/items/new'

export const CREATE_BUNDLE_URL = (id: string | number): string => `/member/${id}/bundles/new`

export const MARK_AS_SOLD_URL = (transactionId: number): string =>
  ` /transactions/${transactionId}/mark_as_sold/new?act_as=sold`

export const ROOT_URL = '/'

export const TRANSACTION_FAQ_ENTRY_URL = (transactionId: number) =>
  `/help/for_transaction/${transactionId}`

export const SIGNUP_URL = '/member/signup/select_type'

export const NEW_ADMIN_ALERT_URL = '/admin_alert/new'

export const HELP_FAQ_ENTRIES_URL = '/help'

export const ESCROW_HELP_URL = '/help/1417'

export const ORDER_DETAILS_URL = (transactionId: number) => `/order_details/${transactionId}`

export const ITEM_URL = (id: number): string => `/items/${id}`
